import React, { useMemo, useState, createContext, useCallback } from "react";
import { uuid } from "../helpers/flows/HelperFunctions";
import { emptyArray } from "../../redux/utils";
import { useContext } from "react";

export const useSubscriptions = ({events = emptyArray}) => {
  
  const ctx = useContext(SubscriptionsContext);

  const [ subscriptors, setSubscriptors ] = useState([]);

  const addSubscriptor = useCallback(({event, id, callback}) => {
    if(events.includes(event)){
      const newid = id || uuid();
      setSubscriptors(subscriptors => [...subscriptors.filter(s => s.id !== newid), {event, id: newid, callback}]);
      return newid;
    }
    return null;
  }, []);

  const removeSubscriptor = useCallback(({event, id}) => {
    setSubscriptors(subscriptors => [...subscriptors.filter(s => s.id !== id && s.event !== event)]);
  }, []);

  const fire = ({event, data}) => new Promise((resolve, reject) => {
    const taskList = subscriptors.filter(s => s.event === event).map(s => s.callback(data));
    Promise.all(taskList)
      .then(result => {
        resolve(!result.some(v => v === false));
      });
  })

  const Context = useMemo(()=>
    ({children})=>{
      return (
        <SubscriptionsContext.Provider value={{addSubscriptor, removeSubscriptor}}>
          {children}
        </SubscriptionsContext.Provider>
      )
    }
  , [addSubscriptor, removeSubscriptor]) 

  

  return {
    Context,
    fire,
    ctx,
  }
}

const SubscriptionsContext = createContext({
  addSubscriptor: ({event = "", id = "", callback = (data) => {}}) => id,
  removeSubscriptor: ({event = "", id = ""}) => {}
});